import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import PlanCard from "./PlanCard";
import NoData from "../components/NoData";
import {setPlanSkeleton} from "../skeleton";

class Plans extends Component {

    render() {
        const {plans, plansIsLoading} = this.props;

        const plansList = plans && plans.length ? plans.map((plan, index) => {
            return (
                <div className="shadow-4d" key={index}>
                    <PlanCard
                        plan={plan}
                        changeAuthFormStatus={(e, status) =>this.props.changeAuthFormStatus(e, status)}
                        changeAuthPopUpStatus={(status) => this.props.changeAuthPopUpStatus(status)}
                        />
                </div>
            )
        })  : (
            <NoData image="no-offers"/>
        );
        return (
            <section id="plans">
                <div className="container ">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="plan-flex-container">
                            {!plansIsLoading ? plansList : setPlanSkeleton(3)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default (withTranslate(Plans));